import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
const FranchiseMenu = () => {
  const x = 0;
  const [contentNav, setContentNav] = useState([]);
  useEffect(() => {
    //
    getSet();
    // getContentNavData();
  }, []);
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);
  const getSet = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "franchise_set_list", {
        params: {
          hqidno: get_cookies("branchidno"),
        },
      })
      .then(function (res) {
        // console.log("res", res.data.data);
        
        const modifiedArray = res.data.data.map(item => ({
          ...item,
          cn_url: "/Franchise-set/"+item.packagetypename.replace(/ /g, "-"),
        }));
        setContentNav(modifiedArray);
        
      })
      .catch(function (error) {
        // console.log(error);
      });
  };
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <h2 className="header-title">Franchise Set</h2>
      </div>
      <div className="page-container">
        {console.log("con", contentNav)}
        <Grid container spacing={2}>
          {contentNav ? (
            contentNav.map((item) => {
              return item.package_type !== "Transaction" ? (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  className="app-card-container"
                  key={item.packagetypename}
                  style={{
                    "--cardBorderColor": "#339933",
                  }}
                > 
                                    <NavLink to={{pathname:item.cn_url,  state: { item }}} key={item.id} >
                                      <div className="app-card">
                                        {item.packagetypename}
                                      </div>
                                    </NavLink>
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  className="app-card-container"
                  key={item.id}
                  style={{
                    "--cardBorderColor": "#339933",
                  }}
                >
                  <NavLink to={"/wholesale-transaction-history/"} key={item.id}>
                    <div className="app-card">
                      {"Wholesale Set Transaction History"}
                    </div>
                  </NavLink>
                </Grid>
              );
            })
          ) : (
            <Preloader />
          )}
        </Grid>
      </div>
    </div>
  );
};

export default FranchiseMenu;
